import xeroxApi from '../axios/xeroxApi';
class ReportService {
    async fetchUserSlaReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allslareport/`, req));
    }

    async fetchSlaDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/sladownloadreport/`, req));
    }

    async fetchMetBreachDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/slametbreachdownloadreport/`, req));
    }

    async fetchUserCustomReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allcustomreport/`, req));
    }

    async fetchUserCustomBusinessTypeDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/custombusinesstypereport/`, req));
    }

    async fetchUserCustomPackMetricsDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/custompackmetricsreport/`, req));
    }

    async fetchUserCustomPackVolumnDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/custompackvolumnreport/`, req));
    }

    async fetchUserCurrentReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allcurrentreport/`, req));
    }

    async fetchUserCurrentCommsDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allcurrentcommsreport/`, req));
    }

    async fetchUserCurrentRPCDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allcurrentrpcreport/`, req));
    }

    async fetchUserDetailsReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/alldetailsreport/`, req));
    }

    async fetchUserReportDetailsChildJobs(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/allchilddetailsreport/`, req));
    }

    async fetchUserDetailsDownloadReport(req) {
        return Promise.resolve(xeroxApi.post(`jobs/reports/alldetailsdownloadreport/`, req));
    }
}

export default ReportService;